module.exports = __webpack_public_path__ + "img/planes.63458741.gif";